export const ASSET_NO_WRITE_PERMISSION_TOOLTIP = 'You do not have permission to edit the asset';
